import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';

@Component({
  selector: 'pxw-geolocation-error-dialog',
  templateUrl: './geolocation-error-dialog.component.html',
  styleUrls: ['./geolocation-error-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class GeolocationErrorDialogComponent {
  readonly modalDialog = viewChild.required(ModalDialogComponent);

  open() {
    return this.modalDialog().open();
  }
}
